import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Input from "../../../../../../components/textbox/Input";
import Utils from "../../../../../../utils/Utils";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";

class Note extends Component {

    state = {
        note: {
            testo: ""
        }
    }


    constructor(props) {
        super(props);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
    }

    componentDidMount() {

        let newState = this.state.note;
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.note) {
            let noteCopia = this.props.segnalazioneCopia.schedaSpeciale.note;
            newState.testo = noteCopia.testo ? noteCopia.testo : "";
            this.setState({note: newState});
        }
        let objectForBackend = Object.assign({}, Utils.removeFieldFromObject({...this.state.note}, "corretto"))
        this.props.setStatePadre(newState, "note", objectForBackend);
    }

    riceviValoreInput(field, event) {
        let newState = this.state.note;
        newState.testo = event.target.value;
        this.setState({state: newState})
        let objectForBackend = Object.assign({}, Utils.removeFieldFromObject({...this.state.note}, "corretto"))
        this.props.setStatePadre(newState, "note", objectForBackend)
    }

    render() {
        const {t} = this.props
        return (
            <div>
                <div><h6>Note</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div>
                        <div id="note" className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaSpecialeEpatiteE.Note.note")}</p>
                            <Input placeholder="Note" type={"textarea"} id={"note"}
                                   value={this.state.note.testo}
                                   field={"note"}
                                   rows={"5"}
                                   onChange={this.riceviValoreInput}
                            />
                        </div>
                    </div>
                </div>
                <div className="row" style={{paddingTop: "3rem"}}>
                    <div className="col-lg-12">
                        <div style={{color: "red", fontWeight: "bold"}}>*Campo obbligatorio</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation('common')(Note)
